module.exports = __webpack_public_path__ + "static/media/iconEye.a4304203.svg";